import { Image } from '@cp/ds/src/components/image';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { ImageAsset } from '../../../../../../../../common/model/resource/image';

export const FeedbackItem: React.FC<{
  text: string;
  image: ImageAsset;
  name: string;
  date: string;
  href?: string;
}> = ({ text, image, name, href, date }) => {
  return (
    <Stack my={{ xs: 5, md: 7.5 }}>
      <Stack direction="row">
        <Image alt={name} asset={image} sx={{ width: 48, height: 48, borderRadius: '50%', overflow: 'hidden' }} />
        <Stack sx={{ ml: 2 }}>
          {href ? (
            <Link external href={href} underline={false}>
              {name}
            </Link>
          ) : (
            <Typography>{name}</Typography>
          )}
          <Typography sx={{ color: 'gray' }} variant="caption">
            {date}
          </Typography>
        </Stack>
      </Stack>
      <Typography sx={{ color: 'gray' }}>{text}</Typography>
    </Stack>
  );
};
